import { combineEpics } from "redux-observable";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import SubscriberResources from "@ane/exp-data/lib/resources/SubscriberResources";
const prefix = "SET_SUBSCRIBERS";
const args = {
  actionPrefix: prefix,
  reduxKeyNested: () => ["value"],
  loadResource: (payload) => {
    return SubscriberResources.setSubscribers(payload);
  },
  onCompleteSuccess: (result, inputPayload) => {
    return result;
  }
};
const SetSubscribersEpicReducer = loadResourcesUtils(args);
const SetSubscribers_epics = combineEpics(SetSubscribersEpicReducer.epic);
export {
  SetSubscribersEpicReducer,
  SetSubscribers_epics as default
};
//# sourceMappingURL=SetSubscribers.epics.js.map
